import { render, staticRenderFns } from "./BookTransfer.vue?vue&type=template&id=63161af4&scoped=true"
import script from "./BookTransfer.vue?vue&type=script&lang=js"
export * from "./BookTransfer.vue?vue&type=script&lang=js"
import style1 from "./BookTransfer.vue?vue&type=style&index=1&id=63161af4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63161af4",
  null
  
)

export default component.exports